<div class="pt-3">
    <mdb-card cascade="true" narrower="true" *ngIf="!vm.workingText && !vm.errorText && !hidden">
        <div class="row">
            <!-- left side -->
            <div class="col-md-8 mr-0">
                <app-card-header [title]="title" [subTitle]="subTitle" [headingSize]="headingSize"
                    [fullHeader]="fullHeader" [dangerText]="dangerText">
                </app-card-header>
            </div>

            <!-- right side -->
            <div class="col-md-4 mt-1 mb-0">
                <div class="row">
                    <div class="col-md-12 text-md-right text-center" *ngIf="vm.actionsAllowed !== false">
                        <div>
                            <a [disabled]="!vm.actionsAllowed" *ngIf="canExportExcel" mdbBtn floating="true" size="sm"
                                gradient="blue" mdbWavesEffect (click)="exportExcel()" mdbTooltip="Export to Excel">
                                <mdb-icon fas icon="file-excel"></mdb-icon>
                            </a>
                            <a [disabled]="!vm.actionsAllowed" *ngIf="canAddNew" mdbBtn floating="true" size="sm"
                                gradient="blue" mdbWavesEffect (click)="add()" mdbTooltip="Add New">
                                <mdb-icon fas icon="plus"></mdb-icon>
                            </a>
                            <a [disabled]="!vm.actionsAllowed" *ngIf="canRefresh" mdbBtn floating="true" size="sm"
                                gradient="blue" mdbWavesEffect (click)="refresh()" mdbTooltip="Refresh">
                                <mdb-icon fas icon="redo-alt"></mdb-icon>
                            </a>
                            <a [disabled]="!vm.actionsAllowed" *ngIf="canGoBack" mdbBtn floating="true" size="sm"
                                gradient="blue" mdbWavesEffect (click)="goBack()" mdbTooltip="Back">
                                <mdb-icon fas icon="arrow-left"></mdb-icon>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <mdb-card-body cascade="true" class="py-2">
        </mdb-card-body>
    </mdb-card>

    <app-page-loader [vm]="vm"></app-page-loader>
</div>